import http from 'axios'

const register = (data) => {
  return http.post('nonAuthOp.php?action=request', data).then(d => d.data)
}

export {
  register
}
